export default __webpack_public_path__ + "static/media/6.48844248.mp4";